import { FC, PropsWithChildren, ReactElement } from 'react';

import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { GameGridContentConnected } from '../content/GameGridContentConnected';
import { useGameGridContext } from '../GameGridContext';

import styles from './GameGridWrapper.module.css';

export const GameGridWrapperConnected: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const {
    refs: { gameGridWrapperRef },
  } = useGameGridContext();

  const isChatModalClosed: boolean = useHighflyerGameStateSlice.getChatClosed();
  const isSecondBetBoardToggle = useHighflyerGameStateSlice.getIsSecondBetBoardToggle();
  const chatClosedMods = useModifiers(
    styles,
    'gameGridWrapper__grid',
    {
      chat_closed: isChatModalClosed,
      singleBetBoard: !isSecondBetBoardToggle,
    },
    { withBaseClass: true }
  );

  return (
    <div className={styles.gameGridWrapper} ref={gameGridWrapperRef}>
      <GameGridContentConnected className={chatClosedMods}>{children}</GameGridContentConnected>
    </div>
  );
};
